import axios from 'axios';
import { ELECTRUM_API_URL } from '../consts';

/**
 * Get list of articles.
 * @param {object} params - The parameters for the request.
 * @param {number} params.page - The page number.
 * @param {number} params.limit - The number of items per page.
 * @param {'spotlight' | 'other'} params.type - The type of article.
 * @param {'blog' | 'news'} params.category - The category of the article.
 */
export const getArticles = async ({
  page = 1,
  limit = 4,
  type = 'other',
  category = 'news',
}) => {
  const result = await axios.get(
    `${ELECTRUM_API_URL}/cms-${category}?page=${page}&limit=${limit}&type=${type}`
  );

  return result.data;
};

/**
 * Get a single article.
 * @param {object} params - The parameters for the request
 * @param {string} params.slug - The slug of the article.
 * @param {'blog' | 'news'} params.category - The category of the article
 */
export const getArticle = async ({ slug, category = 'news' }) => {
  const result = await axios.get(
    `${ELECTRUM_API_URL}/cms-${category}/article?slug=${slug}`
  );

  return result.data;
};
